import { DialogInfo } from "@microsoft/teams-js";
import { CardHelper, Command, GenericConfirmationCard, ImageCardUrlTypes } from "@teams/cards";
import { TeamsApplicationTypes } from "@teams/types";

import { startTask } from "./startTaskWrapper";
import { getAppId } from "./teamsHelpers";

export const startTaskGenericConfirmation = (
  message: string,
  subTitle: string,
  dialogTitle: string,
  applicationType: TeamsApplicationTypes,
  onTaskCompleted: (err: string | undefined, result: string | object |  undefined) => void,
  primaryActionLabel?: string,
  secondaryActionLabel?: string,
  submitCommand?: Command,
  imageType: ImageCardUrlTypes = "WARN",
  showPrimaryAction: boolean = true
) => {
  const errorCard = GenericConfirmationCard(
    message,
    subTitle,
    applicationType,
    primaryActionLabel,
    secondaryActionLabel,
    submitCommand,
    imageType,
    showPrimaryAction
  );
  const taskInfo: DialogInfo = {
    card: CardHelper.toJSONv12String(errorCard),
    title: dialogTitle,
    completionBotId: getAppId(),
    width: 550,
    height: 240,
  };
  startTask(taskInfo, onTaskCompleted);
};
